module.exports = function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramda/src/internal/_isFunction.js
 ** module id = 433
 ** module chunks = 0
 **/